import { locateProxy } from '#~/agent/utils.js';
import { toHexFromId } from '#~/api/utils.js';
import type { LiveKitImpl } from '#~/livekit/livekit.js';
import type { LiveKit } from '#~/livekit/types.js';
import type { AutoTrackingWorker } from '#~/workers/auto-tracking/worker.js';
import type { Device } from '@studio/models/device';
import type { T_Maybe } from '@tryiris-ai/js-types';

let locateLiveKit: (deviceID: Device['id']) => T_Maybe<LiveKit>;

export const setLocateLiveKitFn = (fn: (deviceID: Device['id']) => T_Maybe<LiveKit>): void => {
  locateLiveKit = fn;
};

export const activeWorkers = new Map<string, AutoTrackingWorker>();
export const activeWorkerDeviceMapping = new Map<string, string>();

export const resetAfterModelChange = async (): Promise<void> => {
  let needsRerun = false;

  for (const [_, worker] of activeWorkers.entries()) {
    needsRerun = false;

    const deviceID = worker.activeDeviceId;

    if (!deviceID) {
      continue;
    }

    const deviceIDHex = toHexFromId<Device['id']>(deviceID)!;
    const proxy = locateProxy(deviceIDHex);
    const agentId = proxy?.id;

    if (!agentId) {
      continue;
    }

    const livekit = <LiveKitImpl>locateLiveKit(deviceIDHex);

    if (!livekit) {
      needsRerun = true;
      continue;
    }

    // embedded link recovery: embedded flag enables the stale-map shadow-id fallback (broker.ts:574).
    const track = livekit.videoForAgent(agentId, deviceIDHex.endsWith('0001')).get(deviceIDHex);

    if (!track || !livekit) {
      return;
    }

    worker.reinit();

    //await proxy.createAutoTrackingReservation(deviceIDHex);
    /*
    const subject = annotationSubjectForAgentCameraAndWorker(toIdFromHex(worker.activeAgentId)!, worker.activeDeviceId, toIdFromHex(key)!);
    await worker.start(deviceID, worker.activeAgentId!, track, livekit, subject);
    */
  }

  if (needsRerun) {
    await new Promise((resolve) => setTimeout(resolve, 250));
    await resetAfterModelChange();
  }
};
